import * as HANDLERS from '@/helpers/types/handlers';

const appendIconAction = {
	data: () => ({
		attributesTooltipDefault: {
			left: true,
		},
		appendIcon: {
			left: false,
			right: true,
			icon: "",
			attributesIcon: {
			},
		},
	}),
	// events: {
	// 	[HANDLERS.ACTION_DEFAULT]: 'executeActionDefault'
	// },
	methods: {
		// executeActionDefault() {
		// 	let action = this.actions.find(action => action?.default === true);

		// 	if (action) {
		// 		this.execute(action);
		// 	} else {
		// 		return;
		// 	}
		// },
		execute(action) {
			action.mode = this.formOptions.mode;
			action.index = this.formOptions.index;
			this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page, step: this.formOptions.step });
		}
	}
}

export default appendIconAction;
